import { registerAction } from '../../Action'

const LOAD_GLOBAL_SEARCH_RESULTS = 'LOAD_GLOBAL_SEARCH_RESULTS'

const reducer = (state = {}, action) => ({
  ...state,
  globalSearchResults: action.payload || [],
})

const loadGlobalSearchResults = registerAction(LOAD_GLOBAL_SEARCH_RESULTS, {
  reducer,
})

export default loadGlobalSearchResults
